import React from 'react';
import "./OrderBookThicker.scss";
import { RedDownArrowIcon } from "../../../../assets/Svg/SvgImages.jsx";
import { useSelector } from 'react-redux';
const OrderBookThicker = () => {
  const lastPrice = useSelector(state => state?.ats?.lastPrice);
  return <>
            <div className='orderBookthicker'>
                <div className='d-flex align-items-center'>
                    <h5 className='red_text'>{lastPrice} <RedDownArrowIcon /></h5>
                    <p>= {lastPrice}</p>
                </div>
                {/* <Link className='moreLink' to="#">More</Link> */}
            </div>
        </>;
};
export default OrderBookThicker;